import { h } from 'preact';
import register from '@wcd/preact-custom-element';
import { TESCookieV2 } from './cookies';
import { component as Avatar } from './avatar';
import { ProfileCTA } from '../../../types/web-components';

const domain = window.location.host.split('.').splice(-2)[0];

// desktop masthead stuff
const body = document.body;
const masthead = document.querySelector('.t-masthead');
const toggleMyNav = () => {
  const myNavTop = document.querySelector('.my-nav--top');
  const mastheadProfile = document.querySelector('.masthead__profile');
  if (body) body.classList.toggle('fr-masthead-my-nav-active');
  if (myNavTop) myNavTop.classList.toggle('visible');
  if (mastheadProfile) mastheadProfile.classList.toggle('masthead__profile--active');
}
// mobile masthead stuff
const toggleMobileMyNav = () => {
  if (masthead) masthead.classList.toggle('fr-masthead-mobile-my-nav-logged-in-active');
}
// masthead search
const searchIcon =  document.querySelector('.masthead__search-off');
const closeSearchIcon =  document.querySelector('.masthead__search-on');
if (body && searchIcon) searchIcon.addEventListener('click', function() {
  body.classList.add('fr-masthead-search-active');
});
if (body && closeSearchIcon) closeSearchIcon.addEventListener('click', function() {
  body.classList.remove('fr-masthead-search-active');
});

export const component: ProfileCTA = () => {
  const { userId } = TESCookieV2() || {};
  const isLoggedIn = Boolean(userId);

  // desktop & mobile masthead stuff
  const loggedInToggle = document.querySelector('.masthead__mobile-nav-logged-in-toggle');
  const loggedOutToggle = document.querySelector('.masthead__mobile-nav-logged-out-toggle');
  if (isLoggedIn) body.classList.add('tes-user-loggedin');
  if (!isLoggedIn) body.classList.add('tes-user-loggedout');
  if (loggedInToggle && masthead) loggedInToggle.addEventListener('click', function() {
    masthead.classList.toggle('fr-masthead-mobile-nav-logged-in-active');
  });
  if (loggedOutToggle && masthead) loggedOutToggle.addEventListener('click', function() {
    masthead.classList.toggle('fr-masthead-mobile-nav-logged-out-active');
  });

  if (isLoggedIn) {
    return (
      <div className="tes-user-loggedin">
        <div className="masthead__profile">
          <a
            href="https://www.tes.com/schools/employers/school-chooser"
            className="masthead__primary-link masthead__my-school"
            data-mz
            data-module="masthead"
            data-id="my-school"
          >
            Tes Portal
          </a>
          <div className="masthead__profile-avatar">
            <button
              onClick={toggleMyNav}
              className="masthead__my-nav-toggle"
            >
              <i className="masthead__my-nav-toggle-icon icon icon-close-rebrand icon-white" />
            </button>
            <button
              onClick={toggleMobileMyNav}
              className="masthead__mobile-my-nav-logged-in-toggle"
            />
            <div className="t-masthead-avatar masthead__avatar">
              <Avatar
                width={34} 
                height={34}
              />
            </div>
          </div>
        </div>
      </div>
    );
  }

  return (
    <div>
      <span className="masthead__recruit-cta">
        <a className="masthead__auth-link link link--unstyled" rel="nofollow" href="/for-schools" data-mz="" data-module="masthead" data-id="jobs-recruit">
          <span className="mz-marker"></span>
          Tes for schools
        </a>
      </span>
      <span className="masthead__profile-spacer"/>
      <span className="profile__cta login">
        <a className="masthead__auth-link" href={`https://www.${domain}.com/authn/sign-in?rtn=${window.location.href}`} rel="nofollow">Log in</a>
      </span>
      <span className="masthead__profile-spacer" />
      <span className="profile__cta register">
        <a className="masthead__auth-link link link--unstyled" rel="nofollow" href="/authn/register" data-load-auth="register" data-load-auth-reload="reload" data-load-auth-omitname="true">
          Register <span className="hidden-sm hidden-xs">for free</span>
        </a>
      </span>
    </div>
  )
};

register(component, 'tes-profile-cta', [], { shadow: false });
